module.exports = __webpack_public_path__ + "img/orpi-hayange.41d75538.png";